import React from 'react'
import { FormFieldInterface } from 'src/shared/types/entities/form-interface'
import { BasePublisherCountryField } from '../../base-publisher-field/base-publisher-country-field'
import { useFormField } from '../hooks/use-form-field'

interface FormCountryFieldSubEntityProps {
  fieldSubEntity: FormFieldInterface
}

export const FormCountryFieldSubEntity = ({
  fieldSubEntity,
}: FormCountryFieldSubEntityProps) => {
  const { value, onChange, errors } = useFormField({ fieldSubEntity })
  return (
    <BasePublisherCountryField
      entity={fieldSubEntity}
      value={value}
      onChange={onChange}
      errors={errors}
    />
  )
}
